import Vue from 'vue';
import VueI18n from 'vue-i18n';
import arLocale from './language-ar'
import cnLocale from './language-cn'
import deLocale from './language-de'
import enLocale from './language-en'
import esLocale from './language-es'
import frLocale from './language-fr'
import ptLocale from './language-pt'
import pyLocale from './language-py'
import vnLocale from './language-vn'

Vue.use(VueI18n);

const messages = {
    ar: {
        ...arLocale
    },
    cn: {
        ...cnLocale
    },
    de: {
        ...deLocale
    },
    en: {
        ...enLocale
    },
    es: {
        ...esLocale
    },
    fr: {
        ...frLocale
    },
    pt: {
        ...ptLocale
    },
    py: {
        ...pyLocale
    },
    vn: {
        ...vnLocale
    }
}
const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || 'vn',
    messages,
    // silentFallbackWarn: true,  // 设置为true后，在组件内使用时在浏览器不会报警告
});

export default i18n;